import React from 'react'
import clsx from 'clsx';
import styles from './Sidebar.module.scss'

type SidebarProps = {
  children: React.ReactNode;
  isVisible: boolean;
  onClick: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ children, isVisible, onClick }) => {
  return (
    <div className={clsx(styles.modal, isVisible && styles.visible)}>
      <div className={styles.overlay} onClick={onClick}></div>
      <nav className={clsx(styles.wrapper, isVisible && styles.slide)}>
        <div className={styles.header}>
          <h2 className={styles.headerText}>メニュー</h2>
        </div>
        {children}
      </nav>
    </div>
  )
}

export { Sidebar };